// Charge la base commune
// Styles librairies

// Styles custom
import './scss/pages/blog'

// Scripts librairies
import 'script-loader!./js/libs/paginate/jquery.paginate.min.js'

require('./common.js')

// Pages
// var agenciesPage = require('exports-loader?agenciesPage!./js/pages/agencies.page.js')

// actions principales communes à toutes les pages
$(document).ready(function () {
  // jquery pajinate
  if ($().pajinate) {
    const _container = $('div.pajinate')
    _container.each(function () {
      const _t = $(this)
      const _perPage = _t.attr('data-pajinante-items-per-page') || 5
      const _numLinks = _t.attr('data-pajinante-num-links') || 5
      _t.pajinate({
        items_per_page: parseInt(_perPage),
        num_page_links_to_display: parseInt(_numLinks),
        item_container_id: _t.attr('data-pajinate-container') || '.pajinate-container',
        nav_panel_id: '.pajinate-nav ul',
        show_first_last: true,
        wrap_around: true,
        abort_on_small_lists: true,
        start_page: 0,
        nav_label_prev: '<i class="fa fa-angle-left"></i>',
        nav_label_next: '<i class="fa fa-angle-right"></i>',
        nav_label_first: '<i class="fa fa-angle-double-left"></i>',
        nav_label_last: '<i class="fa fa-angle-double-right"></i>'
      })
    })
  }
})
